import {
  type Language,
  getLanguageFromLocale,
  getZoneFromSite,
  siteConfig,
} from '@seek/melways-sites';
import { reaction } from 'mobx';

import type { EmployerSiteNames } from 'src/siteConfig';
import { getReferenceBalance } from 'src/stores/JobStore/utils/getReferenceBalance';

import { getDashisedBucket } from '../../constants/jobApplicationStatus';
import { trackCandidateManagementPageLoad } from '../../utils/events';
import { getBrandFromSite } from '../../utils/site';
import type { SearchFilters } from '../JobApplicationStore/types';
import type { IStore } from '../Store';

const pageLoadOnUserChange = ({
  store,
  filters,
}: {
  store: IStore;
  filters: SearchFilters;
}) => {
  const BETA_TEST_ID_VALUE = 'loyalty-beta-experience';

  const dispose = reaction(
    () => ({
      user: store.userStore.user,
      jobApplicationsIsLoaded: store.jobApplicationStore.isLoaded,
    }),
    ({ user, jobApplicationsIsLoaded }) => {
      if (user && jobApplicationsIsLoaded) {
        const { jobApplicationStore, seekAdvertiserId, jobStore } = store;
        const { sortBy, total } = jobApplicationStore;
        const { job } = jobStore;
        const testingId = BETA_TEST_ID_VALUE;

        const homeLocationIds = filters.homeLocationIds || [];
        const nationalityIds = filters.nationalityRightToWorkIds || [];

        trackCandidateManagementPageLoad({
          testingId,
          seekAdvertiserId,
          userId: user.userId as number,
          siteLanguage: getLanguageFromLocale(
            store.locale,
          ).toLowerCase() as Language,
          siteCountry:
            siteConfig[store.site as EmployerSiteNames].classification.country,
          zone: getZoneFromSite(store.site),
          brand: getBrandFromSite(store.site),
          sortBy,
          bucket: getDashisedBucket(jobApplicationStore.bucket),
          prospectInBucketCount: total,
          seekListingId: store.jobStore.job.jobInformation.jobId!,
          isSeekReferenceJob: Boolean(job.jobInformation.referenceCheckBalance),
          seekReferenceBalance: getReferenceBalance(
            job.jobInformation.referenceCheckBalance,
          ),
          isCandidateListFiltered:
            filters.rrGlobalFilters.length > 0 ||
            homeLocationIds.length > 0 ||
            nationalityIds.length > 0,
          searchLocationId: homeLocationIds,
          adProductName:
            jobStore.job.jobInformation.productDisplayName || 'Unknown',
          candidateCardStatus: store.getCandidateCardStateForTracking(),
          searchNationalityId: nationalityIds,
        });
        dispose();
      }
    },
  );
};

export default pageLoadOnUserChange;
